
import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Grid, Box, TextField, MenuItem, Autocomplete, RadioGroup, FormControlLabel, Radio, Button, Divider } from '@mui/material';
import { ConstructionOutlined, Padding } from '@mui/icons-material';
import LocationSearchTextBox from '../LocationSearchTextBox';
import countries from "./data/countries"
import colors from "assets/theme/base/colors";
import MDButton from "components/MDButton";
import MDTypography from 'components/MDTypography';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import PropTypes from "prop-types";

const months = [
    {
        Id: 0,
        Name: '1.January'
    },
    {
        Id: 1,
        Name: '2.Frabruary'

    },
    {
        Id: 2,
        Name: '3.Match'
    },
    {
        Id: 3,
        Name: '4.April'
    },
    {
        Id: 4,
        Name: '5.May'
    },
    {
        Id: 5,
        Name: '6.June'
    },
    {
        Id: 6,
        Name: '7.July'
    },
    {
        Id: 7,
        Name: '8.August'
    },
    {
        Id: 8,
        Name: '9.September'
    },
    {
        Id: 9,
        Name: '10.Octomber'
    },
    {
        Id: 10,
        Name: '11.November'
    },
    {
        Id: 11,
        Name: '12.December'
    }

];
const years = [];
const dates = [];
const hours = [];
const minutes = [];

for (var i = 1900; i < 2051; i++) {
    years.push({ id: i, label: i.toString() });
};
for (var i = 1; i <= 31; i++) {
    dates.push({ id: i, label: i.toString() });
}
for (var i = 0; i < 24; i++) {
    hours.push({ id: i, label: i.toString() });
};
for (var i = 0; i <= 59; i++) {
    minutes.push({ id: i, label: i.toString() });
};

const DateTimePlaceEntry = forwardRef(({ onCalculate, genderDefault = null }, ref) => {
    useImperativeHandle(ref, () => ({
      submit() {
        console.log("Submit function called");
        onSubmit();
      }
    }));
    const { t } = useTranslation();
    var dateTimeNow = new Date();
    const [year, setYear] = useState( years.find(x => x.id == dateTimeNow.getFullYear()) );
    const [month, setMonth] = useState(months[dateTimeNow.getMonth()])
    const [date, setDate] = useState(dates.find(x => x.id == dateTimeNow.getDate()))
    const [hour, setHour] = useState(hours.find(x => x.id == dateTimeNow.getHours()))
    const [minute, setMinute] = useState(minutes.find(x => x.id == dateTimeNow.getMinutes()) )
    //const [year, setYear] = useState( );
    // const [month, setMonth] = useState()
    // const [date, setDate] = useState()
    // const [hour, setHour] = useState()
    // const [minute, setMinute] = useState()
    const [country, setCountry] = useState(countries[0])
    const [location, setLocation] = useState(null);
    const [gender, setGender] = useState(genderDefault);
    const [name, setName] = useState("");
    const [formError, setFormError] = useState(false);

    const onLocationChnage = (newLocation) => {
        setLocation(newLocation);
    }
    useEffect(() => {
        console.log("new location is", location);
    }, [location])

    const onSubmit = () => {
        setFormError(true);
        if (year && month && date && validDate() && hour && minute && country && location && gender) {
            setFormError(false)
            onCalculate(
                {
                    year,
                    month,
                    date,
                    hour,
                    minute,
                    location,
                    country,
                    gender,
                    name
                }
            )
            //submit event
        }

    }

    const validDate = ()  =>{
        const testDate = moment(`${year?.id}-${String(month?.Id+ 1).padStart(2, '0')}-${String(date?.id).padStart(2, '0')}`, 'YYYY-MM-DD', true);
        console.log(`${year?.id}-${month?.Id}-${date?.id}`, 'YYYY-MM-DD')
        console.log(testDate)
        console.log(testDate.isValid())
        return testDate.isValid();
        
    }

    return (
        <div style={{ margin: 12 }}>
            <Grid container spacing={2}>
                <Grid item size={12} style={{ borderBottomWidth: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <div><MDTypography variant="h5">{genderDefault ? genderDefault == "F" ? t("Female") + "-" : t("Male")  + "-" : ""}{t("ENTER_LOCATION_AND_TIME")} </MDTypography>
                        <Divider variant="inset" /></div>
                </Grid>

                <Grid item size={3} />
                <Grid item size={{xs:12, sm:3}}>
                    <MDTypography variant="h6">{t("COUNTRY")}</MDTypography>
                    <Autocomplete
                        freeSolo={false}
                        options={countries}
                        defaultValue={country}
                        onChange={(event, value) => { console.log(value); setCountry(value) }}

                        renderOption={(props, option) => {
                            const { ...optionProps } = props;
                            return (
                                <Box
                                    component="li"
                                    sx={{ '& > img': { mr: 2, width: '24px', opacity: 1.0 } }}
                                    {...optionProps}
                                >
                                    <img
                                        loading="lazy"
                                        src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                        alt=""
                                    />
                                    {option.label}
                                </Box>
                            );
                        }}
                        renderInput={(params) => <TextField error={formError && !country} {...params}
                            variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                style: { fontWeight: 'bold' }, // Apply bold style
                                startAdornment: (
                                    <>
                                        {country?.code && <Box component="span" sx={{ display: 'flex', alignItems: 'center', opacity: 1.0 }}>
                                            <img
                                                src={`https://flagcdn.com/24x18/${country?.code.toLowerCase()}.png`}
                                                alt="Flag"
                                                style={{ marginRight: 8, opacity: 1 }}
                                            />
                                        </Box>}</>),
                            }}
                        />}
                    />
                </Grid>
                <Grid item size={{xs:12, sm:3}}>
                    <MDTypography variant="h6">{t("LOCATION")}</MDTypography>
                    {/* <TextField variant="outlined" fullWidth /> */}
                    <LocationSearchTextBox error={formError && !location} onLocationChnage={onLocationChnage} countryCode={country?.code} date={"2000-01-01"} />
                </Grid>
                <Grid item size={3} />
                <Grid item size={3} />
                <Grid item size={{xs:12, md:6,xl:1.2}}>
                    <MDTypography variant="h6">{t("YEAR")}</MDTypography>
                    <Autocomplete freeSolo={false}
                        options={years}
                        defaultValue={year}
                        onChange={(event, value) => { console.log(value); setYear(value) }}
                        disableClearable={true}
                        renderInput={(params) =>
                            <TextField error={formError && !year} {...params}
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    style: { fontWeight: 'bold' } // Apply bold style
                                }}
                            />}
                        renderOption={(props, option) => (
                            <li {...props}>
                              <MDTypography variant="body1" style={{ fontWeight: 'bold' }}>
                                {option.label}
                              </MDTypography>
                            </li>
                          )}
                    />
                </Grid>
                <Grid item size={{xs:12, md:6, xl:1.8}}>
                    <MDTypography variant="h6">{t("MONTH")}</MDTypography>
                    <Autocomplete freeSolo={false}
                        getOptionLabel={(option) => option.Name}
                        options={months}
                        defaultValue={month}
                        onChange={(event, value) => { console.log(value); setMonth(value) }}
                        renderInput={(params) => <TextField error={formError && !month} {...params} variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                style: { fontWeight: 'bold' } // Apply bold style
                            }}
                        />}
                    />
                </Grid>
                <Grid item size={{xs:12, md:6, xl:1}}>
                    <MDTypography variant="h6">{t("DATE")}</MDTypography>
                    <Autocomplete freeSolo={false}
                        options={dates}
                        defaultValue={date}
                        onChange={(event, value) => { console.log(value); setDate(value) }}
                        renderInput={(params) => <TextField error={formError && (!date || !validDate())} {...params} variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                style: { fontWeight: 'bold' } // Apply bold style
                            }}
                        />}
                    />
                </Grid>
                <Grid item size={{xs:12, md:6, xl:1}}>
                    <MDTypography variant="h6">{t("HOUR")}</MDTypography>
                    <Autocomplete freeSolo={false}
                        options={hours}
                        defaultValue={hour}
                        onChange={(event, value) => { console.log(value); setHour(value) }}
                        renderInput={(params) => <TextField error={formError && !hour} {...params} variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                style: { fontWeight: 'bold' } // Apply bold style
                            }}
                        />}
                    />
                </Grid>
                <Grid item size={{xs:12, md:6, xl:1}}>
                    <MDTypography variant="h6">{t("MINUTE")}</MDTypography>
                    <Autocomplete freeSolo={false}
                        options={minutes}
                        defaultValue={minute}
                        onChange={(event, value) => { console.log(value); setMinute(value) }}

                        renderInput={(params) => <TextField error={formError && !minute} {...params} variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                style: { fontWeight: 'bold' } // Apply bold style
                            }}
                        />}
                    />
                </Grid>
                <Grid item size={3} />


                <Grid item size={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <MDTypography  sx={{ color: (formError && !gender) ? 'error.main' : '' }}  variant="h6">{t("Female") + "/" + t("Male")}</MDTypography>
                    <RadioGroup row
                        onChange={(event) => { setGender(event.target.value) }}
                        defaultValue={gender}>
                        <FormControlLabel disabled={genderDefault != null} value="F" control={<Radio />} label={t("Female")} />
                        <FormControlLabel disabled={genderDefault != null} value="M" control={<Radio />} label={t("Male")} />
                    </RadioGroup>
                </Grid>
                <Grid item size={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <MDTypography  sx={{ color: (formError && !gender) ? 'error.main' : '' }}  variant="h6">{t("Name")}</MDTypography>
                    <TextField variant="outlined" onChange={(event)=> setName(event.target.value)}
                            InputProps={{
                                style: { fontWeight: 'bold' } // Apply bold style
                            }}
                        />
                </Grid>
                {!genderDefault && <Grid item size={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <MDButton onClick={onSubmit} variant="contained" color="info" size="large">
                        {t("Calculate")}
                    </MDButton>
                </Grid>}
            </Grid>
        </div>
    );
});

DateTimePlaceEntry.propTypes = {
    onCalculate: PropTypes.func,
    genderDefault : PropTypes.string
};

export default DateTimePlaceEntry;